import * as moment from 'moment';

import { ActionType } from '../../classes/calendar-actions';
import { IEventFilter, IMonth } from '../../classes/calendar';
import { IEvent } from '../../custom/classes/event';
import { removeLoader } from '../../helpers/scroll-to-month';

/**
 * Go to the next month. If necessary, will load data.
 */
export function nextMonth() {
    return {
        type: ActionType.NextMonth
    }
}

/**
 * Go to the last month. If necessary, will load data.
 */
export function previousMonth() {
    return {
        type: ActionType.PreviousMonth
    }
}

export function requestEvents() {
    return {
        type: ActionType.RequestEvents
    }
}

/**
 * Use only after events have been updated.
 */
export function eventsUpdated() {
    return {
        type: ActionType.EventUpdated
    }
}

export function eventError(err: any) {
    return {
        type: ActionType.EventApiError,
        value: err
    }
}

/**
 * Update the events being stored in the redux state.
 * @param events
 */
export function updateEvents(events: IMonth<IEvent>[]) {
    return {
        type: ActionType.UpdateEvents,
        value: events
    }
}

/**
 * Add a number of days to the existing calendar. Will not alter currentDate.
 * @param numberOfDays 
 * @param extendDays 
 */
export function addDays(numberOfDays: number, extendDays: boolean = false) {
    return {
        type: ActionType.AddDays,
        value: { numberOfDays, extendDays }
    }
}

/**
 * Set the startDate and endDate to be the start and end of the input month.
 * @param month 
 */
export function setMonth(month: moment.Moment) {
    return {
        type: ActionType.SetMonth,
        value: month
    }
}

/**
 * Go to the specified month. Will adjust startDate / endDate so that the input month is in the range.
 * @param month 
 */
export function goToMonth(month: moment.Moment) {
    return {
        type: ActionType.GoToMonth,
        value: month
    }
}

export function setDates(startDate: moment.Moment, endDate: moment.Moment) {
    return {
        type: ActionType.SetDates,
        value: { startDate, endDate }
    }
}

export function upsertEventFilter(filterFunction: IEventFilter, shouldUpdateQuery: boolean) {
    return {
        type: ActionType.UpdateEventFilter,
        value: {
            function:
                filterFunction,
            shouldUpdateQuery: shouldUpdateQuery
        }
    }
}

export function removeEventFilter(filterKey: string) {
    return {
        type: ActionType.RemoveEventFilter,
        value: filterKey
    }
}

export function removeAllEventFilters() {
    return {
        type: ActionType.RemoveAllEventFilters
    }
}

export function changeProductionSeasonFilter(filter: number) {
    return {
        type: ActionType.ChangeProductionSeasonFilter,
        value: filter
    }
}